module.exports = __webpack_public_path__ + "media/images/pic/organization_pale-68a7c1c423352cf42e2491293e02ed8f.svg";